import {createSlice} from '@reduxjs/toolkit';

import type {PayloadAction} from '@reduxjs/toolkit';
import type {AppState} from 'src/store/typedef';

type InitialState = {
    users: number[] | null,
};

const initialState: InitialState = {
    users: null,
};

export const updateUsersEntitlementsUsersSlice = createSlice({
    name: 'updateUsersEntitlementsUsers',
    initialState,
    reducers: {
        clearData: state => {
            state.users = null;
        },
        setUsers: (state, action: PayloadAction<number[]>) => {
            state.users = action.payload;
        },
    },
});

export const {
    setUsers,
    clearData,
} = updateUsersEntitlementsUsersSlice.actions;

export const updateUsersEntitlementsUsersSelector =
    (state: AppState) => state.accountPage.tabs.usersAndGroups.updateUserEntitlementsUsers.users;
